import React, {Component} from 'react';
import {graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';
import _ from 'lodash';

const styles = {
  wrapper: {
    padding: 15
  },
};

function getCountries(refinedCommentCounts = [], intl) {
  const countries = refinedCommentCounts
    .filter(item => item.type === 'country' && item.comment !== 'Sweden');
  const sortedCountries = _.orderBy(countries, ['count', 'comment'], ['desc', 'asc']);
  const topCountries = sortedCountries.reduce((arr, item, i) => {
    if (i <= 25) {
      return [...arr, item];
    } else {
      arr[arr.length-1] = {
        comment: intl.formatMessage({id: 'other'}),
        count: arr[arr.length-1].count + item.count,
      };
      return arr;
    }
  }, []);
  return topCountries;
}

function getPercentages(arr) {
  if (!arr) {
    return [];
  }
  const sum = arr.reduce(((acc, opt) => acc + opt.count), 0);
  return arr.map(opt => Math.round((opt.count/sum)*1000)/10);
}

@injectIntl
@withReportFilterProps
@withWidgetData(
  graphql`
    query CountriesWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              refinedCommentCounts {
                comment
                type
                count
              }
              count
            }
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({hideFooter: true})
class CountriesWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;

    const intl = this.props.intl;
    const answersReport = question.answersReport;
    const refinedCommentCounts = answersReport ? answersReport.refinedCommentCounts : [];
    const countries = getCountries(refinedCommentCounts, intl);
    const categories = _.map(countries, 'comment');
    const data = getPercentages(countries);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.bodyHeight-(styles.wrapper.padding*2)-20,
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: null,
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: countries[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y}%'
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: widget.id}}
        />
      </div>
    );
  }
}

export default CountriesWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CountriesWidget/CountriesWidget.js